import { Injectable, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConnectionService } from '@services/connection-service';
import { AppConfig } from 'client/app/app.config';
import { fromActions } from '@store/actions';

@Injectable({ providedIn: 'root' })
export class FollowUpService {
  private readonly _pendingFollowup = signal<any>(null);

  readonly pendingFollowup = this._pendingFollowup.asReadonly();
  // Backwards compatibility: keep `followUp` accessor returning the same signal
  readonly followUp = this.pendingFollowup;

  constructor(
    private readonly store: Store,
    private readonly conn: ConnectionService,
    private readonly appConfig: AppConfig,
  ) {}

  async fetchPendingFollowups(): Promise<void> {
    const defaultWhere: Record<string, unknown> = {
      State: [
        this.appConfig.Shared.Followup.State.PENDING,
        this.appConfig.Shared.Followup.State.WAITING_FOR_IMAGE,
      ],
    };

    this.store.dispatch(fromActions.FollowUpUpdate({ isLoading: true }));

    const followUp = await this.conn.findRecentFollowUp(defaultWhere);

    this._pendingFollowup.set(followUp);

    this.store.dispatch(fromActions.FollowUpUpdate({
      pendingFollowup: followUp ? JSON.parse(JSON.stringify(followUp)) : null,
      isLoading: false,
      hasFetched: true,
    }));
  }

  findFollowUpById(id: string, state: string): any {
    const followUp = this.pendingFollowup();
    if (!followUp) return null;
    if (followUp.id !== id) return null;
    if (followUp.get('State') !== state) return null;
    return followUp;
  }

  findMostRecentPendingFollowUp(pendingState: string): any {
    const followUp = this.pendingFollowup();
    if (!followUp) return null;
    if (followUp.get('State') !== pendingState) return null;
    if (followUp.get('ready')) return null;
    return followUp;
  }


  reset(): void {
    this._pendingFollowup.set(null);
    this.store.dispatch(fromActions.FollowUpUpdate({ pendingFollowup: null, isLoading: false, hasFetched: false }));
  }
}
